const PageHeader = ({ title, breadcrumb, total, customSection }) => (
  <div className="border-b border-divider pb-4 mb-6 flex items-center justify-between">
    {/* LEFT SIDE */}
    <div>
      <h1 className="text-xl font-semibold text-headingText">{title}</h1>
      <p className="text-sm text-descriptionText mt-1">{breadcrumb}</p>
    </div>

    {/* RIGHT SIDE (CUSTOM SECTION) */}
    {customSection && (
      <div className="flex items-center gap-4">{customSection}</div>
    )}
  </div>
);

export default PageHeader;
